class CatalogMode {
  constructor() {
    if (window.theme.catalogMode) {
      this.init();
    }
  }

  init() {
    this.hideCartIcon();
    this.hideQuickView();
    this.hideBuyButtons();
    this.hideStickyAddToCart();
    this.hideQuantitySelectors();
    this.handleCartRedirect();
    this.hidePrice();
  }

  hidePrice() {
    const hidePrices = document.querySelectorAll(
      ".price-list, .predictive-search__products .price-list"
    );
    hidePrices.forEach((icon) => {
      const parentLi = icon.closest("li");
      if (parentLi) {
        parentLi.style.display = "none";
      } else if (icon) {
        icon.style.display = "none";
      }
    });
  }

  hideCartIcon() {
    const cartIcons = document.querySelectorAll(
      ".header__cart-icon, .header__icon--cart, [data-action='open-drawer'][data-drawer-id='sidebar-cart'], .header__cart-link, .header__nav-icon.icon-cart, .header__cart-count, .header__cart-bubble"
    );
    cartIcons.forEach((icon) => {
      const parentLi = icon.closest("li");
      if (parentLi) {
        parentLi.style.display = "none";
      } else if (icon) {
        icon.style.display = "none";
      }
    });
  }

  hideQuickView() {
    const quickViewButtons = document.querySelectorAll(
      ".product-card__quick-buy, .quick-buy-button, [data-action='quick-view'], .product-card__quick-buy-button"
    );
    quickViewButtons.forEach((button) => {
      button.style.display = "none";
    });
  }

  hideBuyButtons() {
    const buyButtons = document.querySelectorAll(
      ".product-form__buy-buttons, .shopify-payment-button, .product-form__add-button, .product__add-to-cart, form[action='/cart/add'], .product-form__submit, .product-form__payment-container, .product-form__checkout-button"
    );
    buyButtons.forEach((button) => {
      if (button) {
        if (button.tagName === "FORM") {
          button.style.display = "none";
        } else {
          button.style.display = "none";
        }
      }
    });
  }

  hideQuantitySelectors() {
    const quantitySelectors = document.querySelectorAll(
      ".quantity-selector, [data-block-type='quantity-selector'], .product-info__block-item[data-block-id='quantity_selector'], .quantity-input, .quantity-selector__button"
    );
    quantitySelectors.forEach((selector) => {
      if (selector) {
        selector.style.display = "none";
      }
    });
  }

  hideStickyAddToCart() {
    const stickyElements = document.querySelectorAll(
      ".product-sticky-bar, .product-form--sticky, .sticky-add-to-cart, .product-sticky-bar__content"
    );
    stickyElements.forEach((element) => {
      if (element) {
        element.style.display = "none";
      }
    });
  }

  handleCartRedirect() {
    if (window.location.pathname === "/cart") {
      window.location.href = "/";
    }
  }
}

// Initialize catalog mode
document.addEventListener("DOMContentLoaded", () => {
  new CatalogMode();
});

// Re-run on dynamic content changes
document.addEventListener("shopify:section:load", () => {
  new CatalogMode();
});
